module.exports = __webpack_public_path__ + "img/低通锐化50.877793ce.png";